import { create } from 'zustand';

export const useResyncModal = create((set) => ({
    isOpen: false,
    resyncData: {},

    onOpen: () => set(() => ({ isOpen: true })),
    onToggle: () => set((prev) => ({ isOpen: !prev })),
    setResyncModal: (newState) => set((state) => ({ ...state, ...newState })),
}));
